//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { FacebookScheduleCalendarAction } from '@facebook/actions/facebookScheduleCalendarActions';
import { FACEBOOK_SCHEDULE_CALENDAR_ACTIONS } from '@facebook/constants/facebookConstants';
import { IFacebookScheduleCalendar } from '@facebook/models/facebookStateModel';
import normalize, { Normalized } from '@utils/normalize';

const initialState: IFacebookScheduleCalendar = {
  posts: Normalized.empty(),
  dateRange: {
    dates: [],
  },
  flags: {
    isFetchingScheduledPosts: false,
  },
  modals: {
    isPostDeletedModalOpen: false,
  },
};

export default function FacebookScheduleCalendarReducer(
  state: IFacebookScheduleCalendar = initialState,
  action: FacebookScheduleCalendarAction,
): IFacebookScheduleCalendar {
  switch (action.type) {
    case FACEBOOK_SCHEDULE_CALENDAR_ACTIONS.REQUEST_SCHEDULED_POSTS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingScheduledPosts: true,
        },
      };
    }
    case FACEBOOK_SCHEDULE_CALENDAR_ACTIONS.RECEIVE_SCHEDULED_POSTS: {
      return {
        ...state,
        posts: normalize(action.posts, (p) => p.id),
        flags: {
          ...state.flags,
          isFetchingScheduledPosts: false,
        },
      };
    }
    case FACEBOOK_SCHEDULE_CALENDAR_ACTIONS.UPDATE_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.dateRange,
      };
    }
    case FACEBOOK_SCHEDULE_CALENDAR_ACTIONS.OPEN_POST_DELETED_MODAL: {
      return {
        ...state,
        modals: {
          ...state.modals,
          isPostDeletedModalOpen: true,
        },
      };
    }
    case FACEBOOK_SCHEDULE_CALENDAR_ACTIONS.CLOSE_POST_DELETED_MODAL: {
      return {
        ...state,
        modals: {
          ...state.modals,
          isPostDeletedModalOpen: false,
        },
      };
    }
    default:
      return state;
  }
}
